import {Action} from '../../../../common/types/common';
import {SimpleMenuState} from '../types/reducers';

export const ON_MOUSE_ENTER_FILE_MENU_ITEM: Action = {
    name: 'ON_MOUSE_ENTER_FILE_MENU_ITEM',
    action: (item: SimpleMenuState) => ({
        item,
        type: ON_MOUSE_ENTER_FILE_MENU_ITEM.name
    })
};

export const ON_MOUSE_LEAVE_FILE_MENU_ITEM: Action = {
    name: 'ON_MOUSE_LEAVE_FILE_MENU_ITEM',
    action: (item: SimpleMenuState) => ({
        item,
        type: ON_MOUSE_LEAVE_FILE_MENU_ITEM.name
    })
};

export const ON_CHANGE_FILE_MENU_ITEM: Action = {
    name: 'ON_CHANGE_FILE_MENU_ITEM',
    action: (item: SimpleMenuState) => ({
        item,
        type: ON_CHANGE_FILE_MENU_ITEM.name
    })
};